export default function AptLoadingIndicatorDirective() {
  'ngInject';

  class loadingIndicatorController {
    isVisible = false;
    aptLoadingIndicatorIconClasses: string[];
    aptLoadingIndicatorClass: string;
    aptLoadingIndicatorBackdrop: boolean;
    aptLoadingIndicatorPromise: Promise<any>;
    aptLoadingIndicatorMessage: string;
    constructor(private $element) {
      'ngInject';
    }

    show() {
      this.isVisible = true;
      this.$element.attr('disabled', 'disabled');
    }

    hide() {
      this.isVisible = false;
      this.$element.removeAttr('disabled');
    }

    showBackdrop(aptLoadingIndicatorBackdrop) {
      if (
        aptLoadingIndicatorBackdrop &&
        aptLoadingIndicatorBackdrop !== undefined
      ) {
        return this.$element.addClass('apt-loading-indicator-backdrop-page');
      } else if (
        !aptLoadingIndicatorBackdrop &&
        aptLoadingIndicatorBackdrop !== undefined
      ) {
        return this.$element.addClass(
          'apt-loading-indicator-backdrop-contextual'
        );
      } else {
        return '';
      }
    }

    hideBackdrop(aptLoadingIndicatorBackdrop) {
      if (
        aptLoadingIndicatorBackdrop &&
        aptLoadingIndicatorBackdrop !== undefined
      ) {
        return this.$element.removeClass('apt-loading-indicator-backdrop-page');
      } else if (
        !aptLoadingIndicatorBackdrop &&
        aptLoadingIndicatorBackdrop !== undefined
      ) {
        return this.$element.removeClass(
          'apt-loading-indicator-backdrop-contextual'
        );
      } else {
        return '';
      }
    }

    $onChanges(changes) {
      if (
        changes.aptLoadingIndicatorPromise &&
        changes.aptLoadingIndicatorPromise.currentValue
      ) {
        this.show();
        this.showBackdrop(this.aptLoadingIndicatorBackdrop);
        changes.aptLoadingIndicatorPromise.currentValue.then(
          // Success
          () => {
            this.hide();
            this.hideBackdrop(this.aptLoadingIndicatorBackdrop);
          },
          // Failure
          () => {
            this.hide();
            this.hideBackdrop(this.aptLoadingIndicatorBackdrop);
          }
        );
      }
      if (
        changes.aptLoadingIndicatorBackdrop &&
        changes.aptLoadingIndicatorBackdrop.currentValue
      ) {
        this.showBackdrop(this.aptLoadingIndicatorBackdrop);
      }
    }
  }

  return {
    restrict: 'A',
    transclude: true,
    template: `<div data-test-selector="apt-loading-indicator"
                    class="apt-loading-indicator"
                    ng-if="$ctrl.isVisible"
                    ng-class="$ctrl.aptLoadingIndicatorClass">
                <i class="apt-loading-indicator-icon apt-circle-notch-icon fa-spin fa-fw" ng-class="$ctrl.aptLoadingIndicatorIconClasses"></i>
                <div class="apt-loading-indicator-message" ng-if="$ctrl.aptLoadingIndicatorMessage">{{$ctrl.aptLoadingIndicatorMessage}}</div>
               </div>
               <ng-transclude ng-if="!$ctrl.isVisible || ($ctrl.aptLoadingIndicatorBackdrop === true || $ctrl.aptLoadingIndicatorBackdrop === false)"></ng-transclude>`,
    scope: {},
    bindToController: {
      aptLoadingIndicatorMessage: '@', // Expects a string
      aptLoadingIndicatorPromise: '<', // Expects an expression
      aptLoadingIndicatorBackdrop: '<', // Boolean
      aptLoadingIndicatorClass: '@', // Expects a string/style class name
      aptLoadingIndicatorIconClasses: '<' // Expects an array of styles, use this in case you want to leverage font-awesome styles example size classes ['fa-lg', 'fa-fx3']
    },
    controllerAs: '$ctrl',
    controller: loadingIndicatorController
  };
}
